import requestAxios from '@/utils/request'

export function loginApi (data) {
  return requestAxios.post('user/auth/login', data)
}

export function logoutApi (data) {
  return requestAxios.post('user/auth/logout', data)
}



// WEBPACK FOOTER //
// ./src/api/auth/login.js